import React, { useState } from 'react';
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
} from '@mui/material';
import RemoveIcon from '@mui/icons-material/Remove'; // Minus icon for expanded state
import AddIcon from '@mui/icons-material/Add'; // Plus icon for collapsed state
import './SellYourMusicFourthSection.scss';
import fblogo from '../../../assets/Images/fb logo.svg';
import linkdln from '../../../assets/Images/linkedin-icon.svg';
import insta from '../../../assets/Images/instagram logo.svg';
import youtube from '../../../assets/Images/youtube logo.svg';
import koko from '../../../assets/Images/Sell your music/Koko Logo.svg';
import GME from '../../../assets/Images/Sell your music/GME Logo.svg';
import FMLogo from '../../../assets/Images/Sell your music/FM FEEL music Logo.svg';
import website from '../../../assets/Images/Sell your music/website-ui-web-svgrepo-com.svg'
import fmlogo from '../../../assets/Images/fmlogo.svg';

function SellYourMusicFourthSection() {
    const [expanded, setExpanded] = useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    return (
        <div className="sell-your-fourth-section">
            <Typography variant="h3" className="section-heading">
                Our Business Group
            </Typography>

            <Accordion
                className="custom-accordion"
                expanded={expanded === 'panel1'}
                onChange={handleChange('panel1')}
            >
                <AccordionSummary
                    expandIcon={expanded === 'panel1' ? <RemoveIcon /> : <AddIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Typography variant="h6" className="accordion-heading">
                        FM FEEL music
                    </Typography>
                </AccordionSummary>
                <AccordionDetails className="accordion-details">
                    <div className="accordion-content">
                        <img
                            src={FMLogo}
                            alt="FM FEEL music"
                            className="accordion-image"
                        />
                        <Typography variant="body2" className="accordion-description">
                            FM FEEL music is a premier record label offering the ideal platform for independent artists to release their music globally.
                        </Typography>
                        <div className="social-icons">
                            {/* <a href="https://www.facebook.com/FMDigital2/ FMDigital2/" target="_blank" rel="noopener noreferrer"><img src={fblogo} alt="Facebook" /></a> */}
                            <a href="https://www.instagram.com/fm_feel_music/" target="_blank" rel="noopener noreferrer"><img src={insta} alt="Instagram" /></a>
                            {/* <a href="https://in.linkedin.com/company/fmdigitalofficial" target="_blank" rel="noopener noreferrer"><img src={linkdln} alt="LinkedIn" /></a> */}
                            <a href="https://www.youtube.com/@FMFEELmusic" target="_blank" rel="noopener noreferrer"><img src={youtube} alt="YouTube" /></a>
                        </div>
                    </div>
                </AccordionDetails>
            </Accordion>

            <Accordion
                className="custom-accordion"
                expanded={expanded === 'panel2'}
                onChange={handleChange('panel2')}
            >
                <AccordionSummary
                    expandIcon={expanded === 'panel2' ? <RemoveIcon /> : <AddIcon />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                >
                    <Typography variant="h6" className="accordion-heading">
                        FM Digital Official
                    </Typography>
                </AccordionSummary>
                <AccordionDetails className='accordion-details' sx={{
                    display: "flex",
                    alignItems: 'center'
                }}>
                    <img
                        src={fmlogo}
                        alt="FM FEEL music"
                        className="accordion-image"
                        style={{
                            width: "120px",
                            height: "120px",
                            marginRight: "17px",

                        }}
                    />
                    <div className="accordion-content">
                        <Typography className='accordion-description' variant="body2">
                            FM Digital Official is a leading digital distribution platform for independent artists and labels. In just 3 years, we've empowered creators to distribute their music across 190+ platforms, including Spotify, Apple Music, Instagram, YouTube, Amazon Music, Pandora, Deezer, Facebook, and many more.

                            With support from FM FEEL Music, our publishing administration service helps artists track streaming income and collect global royalties. Managing an extensive catalog of independent sound recordings, FM Digital Official has distributed $5,000 in earnings to independent artists and labels since our launch.

                        </Typography>
                        <div className="social-icons">
                            <a href="https://www.fmdigitalofficial.com/" target="_blank" rel="noopener noreferrer"><img src={website} alt="Facebook" /></a>
                            <a href="https://www.instagram.com/fmdigitalofficial/" target="_blank" rel="noopener noreferrer"><img src={insta} alt="Instagram" /></a>
                            <a href="https://www.linkedin.com/company/fmdigitalofficial/posts/?feedView=all" target="_blank" rel="noopener noreferrer"><img src={linkdln} alt="LinkedIn" /></a>
                            <a href="https://www.youtube.com/@fm_digital/featured" target="_blank" rel="noopener noreferrer"><img src={youtube} alt="YouTube" /></a>
                        </div>
                    </div>
                </AccordionDetails>
            </Accordion>

            <Accordion
                className="custom-accordion"
                expanded={expanded === 'panel3'}
                onChange={handleChange('panel3')}
            >
                <AccordionSummary
                    expandIcon={expanded === 'panel3' ? <RemoveIcon /> : <AddIcon />}
                    aria-controls="panel3a-content"
                    id="panel3a-header"
                >
                    <Typography variant="h6" className="accordion-heading">
                        Koko Advertising & Marketing
                    </Typography>
                </AccordionSummary>
                <AccordionDetails className='accordion-details'>
                    <div className="accordion-content">
                        <img
                            src={koko}
                            alt="Koko Advertising"
                            className="accordion-image"
                        />
                        <Typography className='accordion-description' variant="body2">
                            Koko Advertising & Marketing is a dynamic advertising and marketing agency, collaborating with top-leading brands across the Indian market.
                        </Typography>
                        <div className="social-icons">
                            <a href="https://kokoadvertising.com/" target="_blank" rel="noopener noreferrer"><img src={website} alt="Facebook" /></a>
                            <a href="https://www.facebook.com/profile.php?id=61560289151077" target="_blank" rel="noopener noreferrer"><img src={fblogo} alt="Facebook" /></a>
                            <a href="https://www.instagram.com/kokoadvertising" target="_blank" rel="noopener noreferrer"><img src={insta} alt="Instagram" /></a>
                            <a href="https://www.linkedin.com/company/fmdigitalofficial/posts/?feedView=all" target="_blank" rel="noopener noreferrer"><img src={linkdln} alt="LinkedIn" /></a>
                            <a href="https://www.youtube.com/@kokoadvertisingmarketing" target="_blank" rel="noopener noreferrer"><img src={youtube} alt="YouTube" /></a>
                        </div>
                    </div>
                </AccordionDetails>
            </Accordion>

            <Accordion
                className="custom-accordion"
                expanded={expanded === 'panel4'}
                onChange={handleChange('panel4')}
            >
                <AccordionSummary
                    expandIcon={expanded === 'panel4' ? <RemoveIcon /> : <AddIcon />}
                    aria-controls="panel4a-content"
                    id="panel4a-header"
                >
                    <Typography variant="h6" className="accordion-heading">
                        Grace Music And Entertainments
                    </Typography>
                </AccordionSummary>
                <AccordionDetails className='accordion-details'>
                    <div className="accordion-content">
                        <img
                            src={GME}
                            alt="Grace Music"
                            className="accordion-image"
                        />
                        <Typography className='accordion-description' variant="body2">
                            Grace Music and Entertainments, based in Hyderabad, distributes sound and event equipment across India. Partnered with over 200 renowned brands like JBL, Shure, Boat, Audient, PreSonus, Arturia, Moog, Dynaudio Pro, SE Electronics, and many more.
                        </Typography>
                        <div className="social-icons">
                            <a href="https://www.gmestoresofficial.com" target="_blank" rel="noopener noreferrer"><img src={website} alt="Facebook" /></a>
                            {/* <a href="https://www.facebook.com/FMDigital2/ " target="_blank" rel="noopener noreferrer"><img src={fblogo} alt="Facebook" /></a> */}
                            <a href="https://www.instagram.com/gracemusicandentertainments?igsh=MW10YjI0MjhjamZo" target="_blank" rel="noopener noreferrer"><img src={insta} alt="Instagram" /></a>
                            {/* <a href="https://in.linkedin.com/company/fmdigitalofficial " target="_blank" rel="noopener noreferrer"><img src={linkdln} alt="LinkedIn" /></a> */}
                            <a href="https://youtube.com/@gracemusicandentertainment?si=v1YpMY7Bhbxph-CO" target="_blank" rel="noopener noreferrer"><img src={youtube} alt="YouTube" /></a>
                        </div>
                    </div>
                </AccordionDetails>
            </Accordion>
        </div>
    );
}

export default SellYourMusicFourthSection;
